<div class="avatar" [style]="avatarStyle()" role="img" [attr.aria-label]="userInitials()">
  {{ displayLabel() }}
</div>
